import { useTranslation } from "react-i18next";

const KEYS = ["1", "2", "3", "4"] as const;

export const Beliefs = () => {
  const { t } = useTranslation();
  return (
    <section id="beliefs" className="relative bg-background py-24 md:py-32 border-t border-border overflow-hidden">
      <div className="glass-orbs" aria-hidden />
      <div className="container-x relative z-10">
        <div className="max-w-3xl mb-16">
          <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-6">
            {t("beliefs.eyebrow")}
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight text-foreground">
            {t("beliefs.title")}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {KEYS.map((k) => (
            <article key={k} className="glass glass-shimmer rounded-2xl p-10 flex gap-8 min-h-[200px] transition-all duration-500">
              <span className="font-display text-2xl font-light text-muted-foreground tabular-nums">
                {String(k).padStart(2, "0")}
              </span>
              <div>
                <h3 className="font-display text-2xl font-medium text-foreground">
                  {t(`beliefs.items.${k}.title`)}
                </h3>
                <p className="mt-4 text-sm text-muted-foreground leading-relaxed">
                  {t(`beliefs.items.${k}.desc`)}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
